import * as React from 'react';
import type { SVGProps } from 'react';

const IconError = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M17.71 4.096a4.667 4.667 0 0 1 6.28 1.646l.004.006 14.128 23.585a4.667 4.667 0 0 1-3.99 7H5.868a4.667 4.667 0 0 1-3.99-7l.01-.018L16.006 5.748l.004-.006a4.667 4.667 0 0 1 1.7-1.646ZM20 6.162a2 2 0 0 0-1.708.96l-.002.003-14.107 23.55a2 2 0 0 0 1.709 2.992h28.217a2 2 0 0 0 1.708-2.992L21.71 7.125l-.002-.003A2 2 0 0 0 20 6.162Z" />
      <path d="M20 13.667c.736 0 1.333.597 1.333 1.333v6.667a1.333 1.333 0 1 1-2.666 0V15c0-.736.597-1.333 1.333-1.333ZM20 25.333c.736 0 1.333.597 1.333 1.334v.833a1.333 1.333 0 1 1-2.666 0v-.833c0-.737.597-1.334 1.333-1.334Z" />
    </g>
  </svg>
);
export default IconError;
